module.exports = __webpack_public_path__ + "img/Exporting_1200x800.3232c4b9.png";